document.addEventListener('DOMContentLoaded', () => {
  const dropdownItems = document.querySelectorAll(
  '.header__menu .menu__item[aria-haspopup="true"], .header__account__dropdown[aria-haspopup="true"]'
);

  dropdownItems.forEach((item) => {
    const dropdown = item.querySelector('.header__dropdown');
    const topLink = item.querySelector('[data-top-link]');
    const dropdownLinks = dropdown ? Array.from(dropdown.querySelectorAll('a')) : [];

    if (!dropdown || !topLink || !dropdownLinks.length) return;

const closeDropdown = () => {
  item.setAttribute('aria-expanded', 'false');
  topLink.setAttribute('aria-expanded', 'false');

  item.classList.remove('is-visible');
  dropdown.classList.remove('is-visible');

  dropdownLinks.forEach((link) => {
    link.setAttribute('tabindex', '-1');
  });
};

const openDropdown = () => {
  item.setAttribute('aria-expanded', 'true');
  topLink.setAttribute('aria-expanded', 'true');

  item.classList.add('is-visible');
  dropdown.classList.add('is-visible');

  dropdownLinks.forEach((link) => {
    link.removeAttribute('tabindex');
  });
};

const observer = new MutationObserver(() => {
  const isOpen =
    item.classList.contains('is-visible') ||
    dropdown.classList.contains('is-visible');

  topLink.setAttribute('aria-expanded', String(isOpen));

  dropdownLinks.forEach((link) => {
    if (isOpen) {
      link.removeAttribute('tabindex');
    } else {
      link.setAttribute('tabindex', '-1');
    }
  });
});

observer.observe(item, {
  attributes: true,
  attributeFilter: ['class']
});

observer.observe(dropdown, {
  attributes: true,
  attributeFilter: ['class']
});

if (item.classList.contains('is-visible')) {
  openDropdown();
} else {
  closeDropdown();
}

    topLink.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
        event.preventDefault();
        openDropdown();
        dropdownLinks[0].focus();
      }

if (event.key === 'Escape') {
  event.preventDefault();
  closeDropdown();
}
    });

    dropdownLinks.forEach((link, index) => {
      link.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          const nextLink = dropdownLinks[index + 1] || dropdownLinks[0];
          nextLink.focus();
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          const previousLink = dropdownLinks[index - 1] || dropdownLinks[dropdownLinks.length - 1];
          previousLink.focus();
        }

if (event.key === 'Escape') {
  event.preventDefault();
  closeDropdown();

  setTimeout(() => {
    topLink.focus();
  }, 0);
}
      });
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        closeDropdown();
      }
    });

    // Hover behavior is handled by <hover-disclosure> in theme.dev.js,
    // where hover disclosure delay is applied.
  });
});

